import { SET_COMPLIANCE_APP_PERMISSONS, SET_COMPLIANCE_CONFIG, SET_COMPLIANCE_MAIN_TAB_DATA, SET_COMPLIANCE_MAIN_ACTIVE_TAB, SET_COMPLIANCE_MAIN_DISABLED_TAB } from '../actions/actionTypes';
import commonConfig from '../../components/commonConfig.json'

const initState = {
    compliancePermissions : {

    },
    qmsPermissions : {

    },
    complianceConfig : {

    },
    complianceMainTabData : {
        // list: [{
        //     key: commonConfig.customTabView.DEFAULT.KEY,
        //     value: commonConfig.customTabView.DEFAULT.TEXT
        // }],
        // active: commonConfig.customTabView.DEFAULT.KEY,
        // disabled:[],
        // tabPosition: "right"
    }
}

const appPermissionsReducer = (state = initState, action) => {
    switch(action.type){
        case SET_COMPLIANCE_APP_PERMISSONS : return {
            ...state,
            compliancePermissions : action.complianceAppPermissions
        }
        case SET_COMPLIANCE_CONFIG : return {
            ...state,
            complianceConfig : action.complianceConfig
        }
        case SET_COMPLIANCE_MAIN_ACTIVE_TAB : return {
            ...state,
            complianceMainTabData : {...state.complianceMainTabData, ...action.compActiveTab}
        }
        case SET_COMPLIANCE_MAIN_DISABLED_TAB : return {
            ...state,
            complianceMainTabData : {...state.complianceMainTabData, ...action.compDisabledTab}
        }
        case SET_COMPLIANCE_MAIN_TAB_DATA : return {
            ...state,
            complianceMainTabData : {...state.complianceMainTabData, ...action.compTabdata}
        }
        default : return state
    }
    
};

export default appPermissionsReducer;